import React, { useEffect, useRef, useState } from 'react'
import Auth from './auth'
import Authorization from '../components/authorization-zakaz/authorization'
import Dashbord from '../components/dashbord/dashbord'
import TableHeader from '../components/dashbord/tableHeader'
import Position from '../components/position/position'
import dashbordStore from '../store/dashbord'
import { observer } from 'mobx-react-lite'
import useSettings from '../hooks/settings.hook'
import Pagination from '../components/pagination/pagination'
import useOrder from '../hooks/order.hook'

import ButtonGrey from '../components/ui/buttonGrey/buttonGrey'
import Loader from '../components/loader/loader'


function Zakaz() {
  const [credentials, setCredentials] = useState({
    token: null,
    orderId: null
  })
  const [data, setData] = useState(false)
  const [initLoading, setInitLoading] = useState(true)
  const [loading, setIsLoading] = useState(false)
  const [message, setMessage] = useState(false)
  const { setPublicSettings } = useSettings()
  const { getZakaz } = useOrder()
  const { order, orders, meta } = data || {}
  const [page, setPage] = useState(1)
  const isFirstRender = useRef(true)

  const {
    settings: { groupView, table },
    selectedPositionsStages,
    selectedPositionsOrderId
  } = dashbordStore

  const syncQueryParamsWithCredentials = ({ token, orderId }) => {
    if (typeof window === 'undefined') return
    if (!token || !orderId) return

    const url = new URL(window.location.href)
    const params = url.searchParams
    params.set('token', token)
    params.set('orderId', orderId)
    url.search = params.toString()

    window.history.replaceState({}, '', url.toString())
  }

  const clearZakazQueryParams = () => {
    if (typeof window === 'undefined') return

    const url = new URL(window.location.href)
    const params = url.searchParams
    params.delete('token')
    params.delete('orderId')
    url.search = params.toString()

    window.history.replaceState({}, '', url.toString())
  }

  const onSubmitHandler = async () => {
    if (credentials.orderId && credentials.token) {
      try {
        setIsLoading(true)
        const data = await getZakaz(credentials)
        if (!data.order) {
          setMessage('Заказ не найден, возможно он не запущен еще в работу, попробуйте позже.')
          return
        }
        setData(data)
        syncQueryParamsWithCredentials(credentials)
      } catch (error) {
        setMessage('Заказ не найден, возможно он не запущен еще в работу, попробуйте позже.')
      } finally {
        setIsLoading(false)
      }
    }
  }

  const onPageChange = page => {
    setPage(page)
  }

  useEffect(() => {
    setPublicSettings()
  }, [])

  useEffect(() => {
    const initFromQueryParams = async () => {
      try {
        if (typeof window === 'undefined') return

        const params = new URLSearchParams(window.location.search)
        const token = params.get('token')?.trim()
        const orderId = params.get('orderId')?.trim()

        if (token && orderId) {
          // Keep credentials in state so pagination requests work too.
          setCredentials({ token, orderId })

          const data = await getZakaz({ token, orderId, page: 1 })
          if (!data?.order) {
            setMessage('Заказ не найден, возможно он не запущен еще в работу, попробуйте позже.')
            return
          }

          setData(data)
        }
      } catch (error) {
        setMessage('Заказ не найден, возможно он не запущен еще в работу, попробуйте позже.')
      } finally {
        setInitLoading(false)
      }
    }

    initFromQueryParams()
    // Intentionally only once on mount, to avoid repeating requests.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }

    ;(async () => {
      const data = await getZakaz({ ...credentials, page })
      setData(data)
      if (typeof window !== 'undefined') {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    })()
  }, [page])

  if (initLoading) {
    return (
      <div className='bg-[#ECDB88] relative min-h-[100vh] w-full flex items-center justify-center'>
        <Loader />
      </div>
    )
  }



  if (order && table) {
    return (
      <div className='flex flex-col gap-2 items-start '>
        <div className='p-[6px]'>
          <ButtonGrey
            onPress={() => {
              setData(false)
              clearZakazQueryParams()
            }}
            name='Назад'></ButtonGrey>
        </div>
        <div className='flex flex-col gap-[0.8rem] min-h-[100px] relative w-[100%] '>
          <div className='bg-Dominant/Dop flex-1'>
            <div className='flex-1   max-w-[96%] w-[calc(100vw-15rem)] m-auto relative overflow-hidden mb-20'>
              <div className='text-Content/Dark block font-semibold text-Regular(24_30) text-center m-5'>
                Даные по заказу {order.orderId}
              </div>

              <table className='product-table'>
                <tbody>
                  <TableHeader
                    isAllMod={true}
                    currentStage={{}}
                    items={order.positions}
                    settings={table}
                    groupView={true}
                    showSelectCheckbox={false}
                    selectedPositionsStages={selectedPositionsStages}></TableHeader>
                  {order.positions.map(position => {
                    const { stage, status } = position.c_position_stages.find(x => x.isCurrentStage)
                    return (
                      <Position
                        {...position}
                        key={position.id}
                        isAllMod={true}
                        stage={stage}
                        status={status}
                        stageInfo={[{ stage, status }]}
                        settings={table}
                        order={order}></Position>
                    )
                  })}
                </tbody>
              </table>
            </div>
            {!!orders?.length && (
              <div className='flex-1   max-w-[96%] w-[calc(100vw-15rem)] m-auto relative overflow-hidden'>
                <div className='text-Content/Dark block font-semibold text-Regular(24_30) text-center m-5'>
                  Остальные заказы
                </div>
                {orders.map(({ id, positions, ...rest }) => {
                  return (
                    <div key={id} className='mb-[2rem]'>
                      <div className='grid items-center gap-[1rem] grid-cols-[auto_1fr] mb-[1.1rem]'>
                        <span className='text-Content/Dark block font-semibold text-Regular(16_18) '>
                          {rest.orderId}{' '}
                        </span>
                      </div>

                      <table className='product-table '>
                        <tbody>
                          <TableHeader
                            isAllMod={true}
                            currentStage={{}}
                            items={positions}
                            settings={table}
                            groupView={true}
                            showSelectCheckbox={false}
                            selectedPositionsStages={selectedPositionsStages}></TableHeader>
                          {positions.map(position => {
                            const { stage, status } = position.c_position_stages.find(x => x.isCurrentStage)
                            return (
                              <Position
                                {...position}
                                key={position.id}
                                isAllMod={true}
                                stage={stage}
                                status={status}
                                stageInfo={[{ stage, status }]}
                                settings={table}
                                order={rest}></Position>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                  )
                })}
              </div>
            )}
          </div>
          {meta?.pageCount > 1 && (
            <div className='max-w-[96%] w-[calc(100vw-15rem)] m-auto p-[1.2rem]  bg-white flex relative'>
              <div className='w-[100%]'>
                <Pagination {...meta} onPageChange={onPageChange} statPage={true}></Pagination>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }

  return (
    <div className='bg-[#ECDB88] flex min-h-[100vh] items-center relative'>
      <div className='absolute left-0 top-0 bottom-0 right-[50%]'>
        <img className='w-[100%] h-[100%] object-cover object-right' src='/auth_bg.png' alt='' />
      </div>
      <div className='w-[95%] m-auto'>
        <div className='max-w-[50%] ml-auto '>
          <div className='bg-white max-w-[76rem]'>
            <Authorization
              message={message}
              loading={loading}
              onSubmitHandler={onSubmitHandler}
              setCredentials={setCredentials}></Authorization>
          </div>
        </div>
      </div>
    </div>
  )
}

export default observer(Zakaz)
